import { useMutation, useQueryClient } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import templateApi from '../services/templateApi';
import { TemplateRequestBody } from '../types/templateRequestBody';
import { BaseQueryKey } from './useTemplate';
import { BaseQueryKey as TemplatesQueryKey } from './useTemplates';

export const useUpdateTemplateDraft = (templateUUID: string) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation(
    (templateBody: TemplateRequestBody) => templateApi.updateTemplateDraft(companyId, templateUUID, templateBody),
    {
      onSuccess: (data) => {
        showToast({
          description: t('template.hooks.update.success'),
          status: 'success',
          title: t('common.toast.success'),
          'data-cy': 'toast-update-draft-success',
        });
        queryClient.invalidateQueries([TemplatesQueryKey]);
        queryClient.invalidateQueries([BaseQueryKey]);
      },
    },
  );
};
